
import { Button } from "@/components/ui/button";
import { SetupGuideDialog } from "./SetupGuideDialog";
import { useState } from "react";
import { BookOpen } from "lucide-react";
import { useTranslation } from "react-i18next";

interface SetupGuideCTAProps {
  type?: "categories" | "contract-types" | "currencies";
  className?: string;
  variant?: "floating" | "card" | "inline";
}

export function SetupGuideCTA({ type = "categories", className, variant = "inline" }: SetupGuideCTAProps) {
  const [showSetupGuide, setShowSetupGuide] = useState(false);
  const { t } = useTranslation();
  
  const messages = {
    "categories": t("noCategoriesMessage", "No categories found. Add some to better organize your contracts."),
    "contract-types": t("noContractTypesMessage", "No contract types found. Add some to better manage your contracts."),
    "currencies": t("noCurrenciesMessage", "No currencies found. Add some to track contract costs.")
  };

  const getButtonStyle = () => {
    if (variant === "floating") {
      return "fixed bottom-4 right-4 z-50 shadow-lg";
    } else if (variant === "card") {
      return "w-full bg-primary text-white hover:bg-primary/90";
    }
    return `flex items-center gap-2 text-muted-foreground hover:text-primary ${className}`;
  };

  return (
    <>
      <Button
        variant={variant === "card" ? "default" : "outline"}
        size="sm"
        className={getButtonStyle()}
        onClick={() => setShowSetupGuide(true)}
      >
        <BookOpen className="h-4 w-4" />
        <span className="text-sm">{messages[type]}</span>
      </Button>
      
      <SetupGuideDialog 
        open={showSetupGuide} 
        onOpenChange={setShowSetupGuide}
        initialStep={type}
      />
    </>
  );
}
